export default {
    N: 'Nacional',
    I: 'Internacional'
}
